import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import NetworkCreateDialog from 'routes/Network/containers/NetworkCreateDialog';
import ProcessOptionsList from './containers/ProcessOptionsList';
import ProcessOptionsCreate from './containers/ProcessOptionsCreate';
import ProcessOptionsEdit from './containers/ProcessOptionsEdit';
import ProcessOptionsView from './containers/ProcessOptionsView';
import { SYSTEM_CONFIGURATION_ROUTE, PROCESS_OPTIONS_ROUTE, SYSTEM } from '../../constants';

interface Props {
}

const ProcessOptions: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${PROCESS_OPTIONS_ROUTE}`}>
        <ProcessOptionsList />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${PROCESS_OPTIONS_ROUTE}/create`}>
        <ProcessOptionsCreate />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${PROCESS_OPTIONS_ROUTE}/edit`}>
        <ProcessOptionsEdit />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SYSTEM}${PROCESS_OPTIONS_ROUTE}/view`}>
        <ProcessOptionsView />
      </Route>
      <NetworkCreateDialog />
    </Fragment>
  );
};

export default ProcessOptions;
